import { selectFeatureFlags } from 'core/userContext';
import { getIsJourneyExitEventsEnabled } from 'modules/workflows/ducks';
import { useSelector } from 'react-redux';
import { PageHeader } from 'ui/pageHeader';
import { Body2, H4 } from 'ui/theme';
import { ContentWrapper, LeftContent, PageWrapper, RightContent } from './BillingPage.styled';
import { BillingPagePageActions as PageActions } from './BillingPagePageActions';
import { CatalogCard } from './catalog/CatalogCard';
import { CustomEventsCard } from './customEvents/CustomEventsCard';
import { GlobalSmsCard } from './globalSms/GlobalSmsCard';
import { GlobalWhatsAppCard } from './whatsApp/GlobalWhatsAppCard';
import { JourneyEventsCard } from './journeyEvents/JourneyEventsCard';
import { MessagingCard } from './messaging/MessagingCard';
import { PaymentsMigratedCard } from './PaymentsMigratedCard';
import { SmartIngestCard } from './smartIngest/SmartIngestCard';
import { UsersCard } from './users/UsersCard';

export const TEXT = {
  HEADER: 'Usage and Billing',
  USAGE_HEADING: 'Usage',
  USAGE_DESCRIPTION:
    'Organization usage metrics are a summary of your usage metrics across all of your projects for a selected time period. Each category also allows you to view a project level usage breakdown. Lifetime metrics are calculated based on current totals and will not update based on the selected time period.',
  PAYMENTS_HEADING: 'Payment information',
  PAYMENTS_SUBHEADING: 'Credit cards',
};

export const BillingPage = () => {
  const isJourneyExitEventsEnabled = useSelector(getIsJourneyExitEventsEnabled);
  const { WhatsAppMessageChannelGA } = useSelector(selectFeatureFlags);
  return (
    <PageWrapper>
      <PageHeader pageActions={<PageActions />}>{TEXT.HEADER}</PageHeader>
      <ContentWrapper>
        <LeftContent>
          <H4>{TEXT.USAGE_HEADING}</H4>
          <Body2>{TEXT.USAGE_DESCRIPTION}</Body2>
        </LeftContent>
        <RightContent>
          <MessagingCard />
          <GlobalSmsCard />
          {WhatsAppMessageChannelGA && <GlobalWhatsAppCard />}
          <UsersCard />
          <CustomEventsCard />
          {isJourneyExitEventsEnabled && <JourneyEventsCard />}
          <CatalogCard />
          <SmartIngestCard />
        </RightContent>
      </ContentWrapper>
      <ContentWrapper>
        <LeftContent>
          <H4>{TEXT.PAYMENTS_HEADING}</H4>
        </LeftContent>
        <RightContent>
          <H4>{TEXT.PAYMENTS_SUBHEADING}</H4>
          <PaymentsMigratedCard />
        </RightContent>
      </ContentWrapper>
    </PageWrapper>
  );
};
